<template>
  <!--PPAP检验计划-->
  <h-list-page>
    <h-card :title="h_i18n('13fe8d8c74cb94357d8e105686778dfe')" width="100%" footer is-search @change-method="changeMethod">
      <h-area>
        <h-search :title="h_i18n('1d2a691eda00b5b04a5911dfb42c2e22')">
          <h-input v-model="searchData.patternPlanId" clearable></h-input>
        </h-search>
        <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">
          <h-autocomplete
              popper-class="planHidden"
              v-model="searchData.mtlNo"
              :fetch-suggestions="mtlNoChange"
              :trigger-on-focus="false"
              @input="() =>searchData.mtlNo.length < 4? (plan.showMtlPlan = false): ''"
              @clear="plan.showMtlPlan = false"
              clearable
              :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')"
              @blur="myBlur('showMtlPlan')"
              @focus="myFocus3('showMtlPlan')"
          >
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0px">
            <el-table v-show="plan.showMtlPlan" v-loading="loading.mtlLoading" ref="filterTable" :data="mtlNoList" border size="small" max-height="252" @row-click="clickMtlNo" @mousedown="planBlur=true">
              <el-table-column prop="mtlNo" :label="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')" width="120"></el-table-column>
              <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
            </el-table>
          </h-detail>
        </h-search>
        <!-- <h-search title="供应商代码">
          <h-autocomplete
              popper-class="planHidden"
              v-model="searchData.supplyCode"
              :fetch-suggestions="supplyCodeChange"
              :trigger-on-focus="false"
              @input="() =>searchData.supplyCode.length < 2? (plan.showSupplyPlan = false): ''"
              @clear="plan.showSupplyPlan = false"
              clearable
              placeholder="请输入至少两位供应商代码"
              @blur="myBlur('showSupplyPlan')"
              @focus="myFocus4('showSupplyPlan')"
          >
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0">
            <el-table v-show="plan.showSupplyPlan" v-loading="loading.supplyLoading" ref="filterTable" :data="supplyCodeList" border size="small" max-height="252" @row-click="clickSupplierCode" @mousedown="planBlur=true">
              <el-table-column prop="supplyCode" label="供应商代码" width="120"></el-table-column>
              <el-table-column prop="supplyName" label="供应商名称"></el-table-column>
            </el-table>
          </h-detail>
        </h-search> -->
        <h-search :title="h_i18n('aae11e21d2ef24d030976e023bc44ff5')">
          <h-input v-model="searchData.mtlName" clearable></h-input>
        </h-search>
        <!-- <h-search title="外检经理">
          <h-input v-model="searchData.iqcManagerId" clearable placeholder="请输入工号"></h-input>
        </h-search>
        <h-search title="SQE经理">
          <h-input v-model="searchData.sqeManagerId" clearable placeholder="请输入工号"></h-input>
        </h-search> -->
        <h-search :title="h_i18n('03490f3868798323211aa633194df2c1')">
          <h-select v-model="searchData.sybId" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" style="width: 196px" clearable filterable>
            <h-option v-for="(item, index) in sybList" :key="index" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <!-- <h-search title="物料大类">
          <h-select style="width: 100%" v-model="searchData.materielCategoryId" placeholder="请选择" clearable filterable>
            <h-option
                v-for="item in materielCategoryNameList"
                :key="item.materielCategoryName"
                :label="item.materielCategoryName"
                :value="item.materielCategoryId"
            >
            </h-option>
          </h-select>
        </h-search> -->
        <!-- <h-search title="检验方式">
          <h-select v-model="searchData.checkTypeId" placeholder="请选择" clearable>
            <h-option v-for="item in inspectionMethod" :key="item" :label="item.label" :value="item.value"></h-option>
          </h-select>
        </h-search> -->
        <!-- <h-search title="PPAP状态">
          <h-select v-model="searchData.ppapStatus" placeholder="请选择" style="width: 196px" clearable>
            <h-option v-for="item in ppapStatusList" :key="item" :label="item.label" :value="item.value"></h-option>
          </h-select>
        </h-search> -->

        <h-search :title="h_i18n('50ea8ae3fd3e7dd7af522d1c34d636ca')">
          <h-date-picker @change="dateMapChange('planDate',dateMap.planDate)" v-model="dateMap.planDate" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>
        <h-search :title="h_i18n('516d37e436ca866ebe56ae51f96374e8')">
          <h-date-picker @change="dateMapChange('realityDate',dateMap.realityDate)" v-model="dateMap.realityDate" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>
        <h-search :title="h_i18n('79b7b25d969728e35f87f7c64e41f646')">
          <h-date-picker @change="dateMapChange('sendDay',dateMap.sendDay)" v-model="dateMap.sendDay" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>

        <template #operate>
          <h-button type="primary" :loading="loading.tableListLoading" @click="paginationQuery(1)">
            <template #icon>
              <search/>
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>
      </h-area>
    </h-card>
    <div style="position: relative;margin-top: 10px;">
      <h-table-card :title="h_i18n('563b75e45e2c97e1ff6c16386976c976')" :is-left="1" :h-data="tableDataList" :is-right="1">
        <template #buttonGroup>
          <h-button-group>
            <h-button type="default" :loading="loading.export" @click="derive()" v-if="btnListOfSqm.some(item=>item.code == 'mkhl_ppap_jh_DC')">{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}<template #icon>
                <export/>
              </template>
            </h-button>
          </h-button-group>
        </template>

        <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="loading.table" height="540"
                  @selection-change="listCheckBoxChange" border :data="tableDataList" size="small"
                  style="width: 100%;min-height: 540px;">
          <el-table-column prop="sqmStatus" :label="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')" width="170">
            <template #default="{row}">
              <div style="cursor:pointer;" :class="sqmStatusFormatter(row.sqmStatus)" @click="ppapApplicabilitySelfInspectionUpload(row)">{{ ppapStatusFormatter(row.sqmStatus) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="patternPlanId" :label="h_i18n('1d2a691eda00b5b04a5911dfb42c2e22')" width="220">
            <template #default="{row}">
              <span style="color: #2164f5; cursor: pointer; text-overflow: ellipsis; overflow: hidden; display: block" @click="openDetail(row)">{{ row.patternPlanId }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sendDay" :label="h_i18n('4ff1e74e43a3586339251494117185ad')" width="170" :formatter="timeFormatter"></el-table-column>
          <!--          <el-table-column prop="checkTypeName" label="产品大类" min-width="60"></el-table-column>-->
          <el-table-column prop="sybName" :label="h_i18n('03490f3868798323211aa633194df2c1')" min-width="120"></el-table-column>
          <el-table-column prop="materielCategoryName" :label="h_i18n('8e808f51e7025756613a867dee579ab3')" min-width="120"></el-table-column>
          <el-table-column prop="mtlName" :label="h_i18n('aae11e21d2ef24d030976e023bc44ff5')" min-width="200"></el-table-column>
          <el-table-column prop="materialLevel" :label="h_i18n('c63692128c6ae23d666bcfbe0a1054c3')" width="60"></el-table-column>
          <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" min-width="120"></el-table-column>
          <el-table-column prop="ppapConclusion" :label="h_i18n('54bbba803f13eaab0f5441d97b13247a')" min-width="80">
            <template #default="{row}">
              <span v-if="row.ppapConclusion == 'P'" class="successColor">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column prop="planDate" :label="h_i18n('ce91e71085bbb53294bc5d42dccb3ad6')" width="170" :formatter="timeFormatter"></el-table-column>
          <el-table-column prop="realityDate" :label="h_i18n('516d37e436ca866ebe56ae51f96374e8')" width="170" :formatter="timeFormatter"></el-table-column>
          <el-table-column prop="checkTypeName" :label="h_i18n('6643ded0025cc29815fe4bd5ff7ae566')" width="100"></el-table-column>
          <el-table-column prop="assessId" :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')" min-width="50">
            <template #default="{row}">
              <span class="h-global-font--blue" style="margin-left: 8px;" @click="openPPAPProcess(row)">{{ h_i18n('f630b9a4da10f81b7bb1c75bf6345558') }}</span>
            </template>
          </el-table-column>
        </el-table>
        <template #pagination>
          <el-pagination background @current-change="paginationQuery" v-model:current="pageNation.pageIndex"
                         :page-size="10" layout="total, prev, pager, next,jumper" :total="pageNation.total">
          </el-pagination>
        </template>
      </h-table-card>
    </div>
    <!-- 流程 -->
    <h-dialog :title="h_i18n('ae762b31e735d05f32b0f8aef726da64')" :show="ppapProcessShow" width="70%" @close="ppapProcessClose">
      <el-table :data="ppapProcessList.slice((processPageNo-1)*20,processPageNo*20)"
          v-loading="ppapProcessDialogLoading" border size="small">
          <el-table-column prop="stage" :label="h_i18n('d316330b742ea7b420665a3df7ec374d')" min-width="140">
            <template #default="{ row }">
              <span v-if="row.stage === 1">{{ h_i18n('e3452eba8e848e0019818a56062c7346') }}</span>
              <span v-else-if="row.stage === 2">{{ h_i18n('8ac399bf0a389c62337625923649b685') }}</span>
              <span v-else-if="row.stage === 3">{{ h_i18n('cc457a70b129995efbebe2217b0f441d') }}</span>
              <span v-else-if="row.stage === 4">{{ h_i18n('412b229f1c250942327245f08107154b') }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="role" :label="h_i18n('8402fcdd8d97edd86fb1bc69059db687')" min-width="100"></el-table-column>
          <el-table-column prop="createDateTime" :label="h_i18n('19fcb9eb2594059036dfede5f4ec53e8')" min-width="170"></el-table-column>
          <el-table-column prop="flagVal" :label="h_i18n('54bbba803f13eaab0f5441d97b13247a')" min-width="100"></el-table-column>
          <el-table-column prop="approveDetail" :label="h_i18n('a6396f13c260444d561afaa9407467be')" width="200"></el-table-column>
        </el-table>
        <el-pagination background @current-change="processCurrentChange" v-model:currentPage="processPageNo"
                     :page-size="20" layout="total, prev, pager, next,jumper" :total="processPageTotal" :hide-on-single-page="processPageTotal <= 20">
      </el-pagination>
    </h-dialog>
  </h-list-page>
</template>



<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';


import axios from "axios";
import {DataFormatter, Export, Loading, LoadingButton, Request, Time, Trim} from "../../../Decorator/vue2-decorator";

export default {
  name: "PPAPApplicabilityEvaluationList",
  data() {
    return {
      // 流程参数 -->
      ppapProcessDialogLoading:false,
      ppapProcessShow:false,
      ppapProcessList:[],
      processPageNo:1,
      processPageTotal:0,
      // <--- 流程参数
      btnListOfSqm:[],
      searchData: {
        mtlNo: "",
        supplyCode: ""
      },
      loading: {
        export: false,
        table: false
      },
      pageNation: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      http: {
        mtlSearchHttp: null,//专用号模糊查询
      },
      sybList:[],
      name: "",
      dateMap: {
        sendDay: null,
        supplySendSampleDate: null,
      },
      roleCode: "",//角色
      multipleSelection: [],//选中
      tableDataList: [],//列表
      plan: {showMtlPlan: false},//专用号弹窗
      sqmStatus: {},
      submitStatus: [],
      publishStatus: [],
      sqmStatusColor: {}
    }
  },
  computed: {
    clearAble() {
      let list = Object.keys(this.dateMap)

      let a = list.filter(v => {
        return !!this.dateMap[v];
      })
      return a.length > 1;
    }
  },

  methods: {
    h_i18n,
    //六位时间格式化函数
    @Time(3, "yyyy-MM-dd HH:mm:ss")
    timeFormatter(text) {return text},

    @DataFormatter(1, "sqmStatus")
    ppapStatusFormatter(value) {return value},

    @DataFormatter(1, "sqmStatusColor")
    sqmStatusFormatter(value) {return value},


    changeMethod() {
      this.postThisPageHeight()
    },
    lookDetails(row) {
      this.$router.push({
        name: "PPAPApplicabilityEvaluationDetail/SQM",
        query: {
          assessId: row.assessId
        }
      })
    },
    setSqmStatus() {
      let ob = {}
      let list = [h_i18n('a9c09d3297b708f0ff815a93ec5f4145'), h_i18n('0737ae75a2dd50d9768cdb884441e6c5'), h_i18n('482bc9be1a99158278c87b6fe698bcc6'), h_i18n('bdfe622df1e3a041279584677e8b2d94'), h_i18n('0cb4d0f2885776a1ebe7fa9c835fc3c5'), h_i18n('d8acae3bcfbc9ec9ade58c2dbacf65aa')]
      for (let i = 1; i <= 4; i++) {
        for (let j = 0; j < 5; j++) {
          ob[i + "" + j] = `${h_i18n('ac007746080a48f195815c62f8c1570c')}${i}${h_i18n('d316330b742ea7b420665a3df7ec374d')}${list[j]}`
          if ([0, 2, 4, 5].includes(j)) {
            this.submitStatus.push(i + "" + j)
            if (j === 2 || j === 4) {
              this.sqmStatusColor[(i + "" + j)] = "dangerColor"
            } else {
              this.sqmStatusColor[(i + "" + j)] = "h-global-font--blue"
            }
          } else if (j === 1) {
            this.publishStatus.push(i + "" + j)
            this.sqmStatusColor[(i + "" + j)] = "h-global-font--blue"
          } else {
            this.sqmStatusColor[(i + "" + j)] = "h-global-font--blue"
          }
        }
      }
      this.sqmStatus = ob
      this.sqmStatus["all"] = h_i18n('cd634a2b4c9d2ca636c2cb4dd74a357b')
    },
    // 流程方法 -->
    // 流程查看 ppapProcessShow
    openPPAPProcess(row){
      this.ppapProcessShow = true
      this.ppapProcessDialogLoading = true
      this.ppapProcessList = []
      this.processPageTotal = 0
      if(!row.patternPlanId){
        return
      }
      // 接口 
      this.$http({
        method: "get",
        url: "/base/patternPlan/ppapPlanProcessNodeList?patternPlanId="+row.patternPlanId,
      }).then(res => {
        if(res.data.code === '200'){
          this.ppapProcessList = res.data.data
          this.processPageTotal = res.data.data.length
        }
      }).catch(err=>{
        console.log(err)
        this.ppapProcessList = []
      }).finally(()=>{
        this.ppapProcessDialogLoading = false
      }) 
    },
    // 关闭查看
    ppapProcessClose(){
      this.ppapProcessShow = false
      this.ppapProcessList = []
      this.ppapProcessDialogLoading = false
    },
    // dialog table 翻页
    processCurrentChange (v) {
      this.processPageNo = v
    },
    // <-- 流程方法
    async init() {
      this.roleCode = this.$route.query.roleCode
      window.getItemName = this.$route.query.name;
      window.getItemNickName = this.$route.query.nickName;
      await this.paginationQuery(this.pageNation.pageIndex)
      this.setSqmStatus()
      this.getSybListAdd()
    },

    @Trim(['', null])
    ppapApplicabilitySelfInspectionUpload(row) {
      if (this.submitStatus.includes(row.sqmStatus)) {
        if (this.authentication(1)) {
          this.$router.push({
            name: "PPAPApplicabilitySelfInspectionUpload/SQM",
            query: {
              name: this.$route.query.name,
              nickName: this.$route.query.nickName,
              ...this.$route.query,
              data: JSON.stringify(row),
            },
          })
        }
      } else if (this.publishStatus.includes(row.sqmStatus)) {
        if (this.authentication(2)) {
          this.$router.push({
            name: "PPAPApplicabilitySelfInspectionPublish/SQM",
            query: {
              name: this.$route.query.name,
              nickName: this.$route.query.nickName,
              ...this.$route.query,
              data: JSON.stringify(row),
            },
          })
        }
      } else if (["13", "23", "33", "43"].includes(row.sqmStatus) || row.sqmStatus === "all") {
        this.$router.push({
          name: "PPAPApplicabilitySelfInspectionDetail/SQM",
          query: {
            name: this.$route.query.name,
            nickName: this.$route.query.nickName,
            ...this.$route.query,
            data: JSON.stringify(row),
            kindType:'sqmDetail',
          },
        })
      }
      console.log(row)

    },
    // 获取工厂小微
    getSybListAdd () {
      this.$http({
        method: "get",
         url: "/base/OqcA/listSyb",
      }).then((res) => {
        this.sybList = res.data.map(item=>{
          return {valueName: item.departmentName,valueId: item.departmentId}
        })
      });
    
    },
    openDetail(row){
      this.$router.push({
          name: "PPAPApplicabilitySelfInspectionDetail/SQM",
          query: {
            name: this.$route.query.name,
            nickName: this.$route.query.nickName,
            ...this.$route.query,
            data: JSON.stringify(row),
            kindType:'sqmDetail',
          },
        })
    },
    dateMapChange(item, value) {
      if (value) {
        this.searchData[item + 'Start'] = this.time(value[0], 3)
        this.searchData[item + 'End'] = this.time(value[1], 3)
      } else {
        this.searchData[item + 'Start'] = ""
        this.searchData[item + 'End'] = ""
      }
    },
    authentication(v) {
      if (v === 1) {//模块提交人
        if (["S003", "S009"].includes(this.roleCode)) {
          return true
        } else {
          this.info(h_i18n('dbd50d982590555ba1a796939ed3025a'))
          return false
        }
      } else if (v === 2) {
        if (["S002", "S006", "S000"].includes(this.roleCode)) {
          return true
        } else {
          this.info(h_i18n('572025dd8eb3bd12e116ee4c2fba388c'))
          return false
        }
      }
    },
    @Loading(h_i18n('d5909c33688b64afc6be256556a9a24c'))
        @LoadingButton("export")
        @Export(h_i18n('519bb8cd7b576be38c7993ee73fee042'))
        @Request("vmiService")
    derive() {
      if (this.pageNation.total > 5000) {
        this.info({
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          message: h_i18n('748c802d8fe36ada78520df791295747'),
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        })
      } else {
        return request({
          method: "post",
          url: "/patternPlan/exportPpapPlanListSqm",
          data: {
            ...this.searchData,
            supplyCode: this.$route.query.name,
            userId: "SUPPLY",
            userName: this.$route.query.nickName
          },
          responseType: "blob",
        })
      }
    },
    paginationQuery(val) {
      this.pageNation.pageIndex = val;
      this.searchTableList();
    },

    @LoadingButton("table")
    @Request("vmiService")
    searchTableList() {
      let params = {...this.searchData};
      params.userId = "SUPPLY"
      params.supplyCode = this.$route.query.name;
      return request({
        method: "post",
        url: "/patternPlan/ppapPlanListPage",
        data: {
          ...this.pageNation,
          ...params,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          if (res.data.data.records) {
            this.tableDataList = res.data.data.records.map(v => ({...v, loading: false, config: false}));
            this.pageNation.total = res.data.data.total;
          } else {
            this.tableDataList = [];
            this.pageNation.total = 0;
          }
        }
      }).catch((err) => {
        this.error(h_i18n('0d66ed02d74d0bd89431d6d59533ffb3') + err)
      });
    },
    /**
     * 处理两个查询
     * *******************************************************************************
     */
    myBlur(v) {
      if (!this.planBlur) {
        this.plan[v] = false;
      }
    },
    myFocus3(v) {
      this.planBlur = false
      if (this.searchData.mtlNo.length >= 4) {
        this.plan[v] = true;
      }
    },
    // 供应商获取焦点
    myFocus4(v) {
      this.planBlur = false;
      if (this.searchData.supplyCode.length >= 2) {
        this.plan[v] = true;
      }
    },
    /**
     * 专用号模糊查询
     */
    mtlNoChange() {
      this.planBlur = false;
      if (this.http.mtlSearchHttp) this.http.mtlSearchHttp.cancel()
      this.http.mtlSearchHttp = axios.CancelToken.source()
      if (this.searchData.mtlNo.length < 4) {
        this.plan.showMtlPlan = false;
      } else {
        this.loading.mtlLoading = true;
        this.plan.showMtlPlan = true;
        this.$http({
          method: "POST",
          url: "/base/basicData/searchMaterielList",
          headers: {"content-type": "application/json"},
          data: {
            mtlNo: this.searchData.mtlNo,
          },
          cancelToken: this.http.mtlSearchHttp.token
        }).then((res) => {
          this.mtlNoList = res.data.data;
          this.loading.mtlLoading = false;
        }).catch(e => {
        });
      }
    },
    clickMtlNo(row) {
      this.searchData.mtlNo = row.mtlNo;
      this.plan.showMtlPlan = false;
    },
    listCheckBoxChange(val) {
      this.multipleSelection = val;
    },

  },
  mounted() {
    this.init()
    if(this.$route.query.parentId && this.$route.query.parentId != 'null' && this.$route.query.parentId != 'undefined' && this.$route.query.parentId != ''){
    let p = this.getButtonFromSqm(this.$route.query.parentId,this.$route.query.roleCode)
    p.then(res=>{
      if(res.length > 0){
        this.btnListOfSqm = res
      }
    })
    }else{
      this.btnListOfSqm = [
        {code:'mkhl_ppap_jh_DC',name:h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95')},
      ]
    }
  },
  activated() {}
};
</script>

<style lang="scss">
.default-box::-webkit-scrollbar {
  background-color: transparent;
  width: 8px;

}

.default-box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: #000;
}

.el-overlay {
  z-index: 1998 !important;
}

.planHidden {
  display: none;
}
</style>

<style lang="scss" scoped>

:deep(.el-table__row) {
  td:last-child {
    .cell {
      overflow: hidden !important;
    }
  }
}

.picture-list {
  height: 500px;
  overflow-y: auto;

  .picture-list-item {
    cursor: pointer;
    display: inline-block;
    padding: 10px;
    max-width: 100%;
    box-sizing: border-box;
  }
}

.picture-list::-webkit-scrollbar {
  background-color: transparent;
  width: 8px;

}

.picture-list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: #000;
}

.blueColor {
  color: #2681ff;
}

.dangerColor {
  color: #ff4d4f;
}

.successColor {
  color: #52c41a;
}

.warningColor {
  color: #E6A23C;
}

.pointer {
  cursor: pointer;
}

.item_one {
  padding: 0 !important;
}

tbody {
  .is-left {
    .cell {
      text-align: left !important;
    }
  }
}

.is-cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.is-cell:hover {
  white-space: normal;
}

.planHidden {
  display: none;
}

.el-table__row {
  td:last-child {
    .cell {
      overflow: visible;
    }
  }
}

:deep(.el-drawer__header) {
  margin-bottom: 10px;
  padding: 0 10px;
  font-weight: 900;
  border-bottom: 1px dashed #ccc;
}

.titleDrawer {
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
}

.default-body {
  display: flex;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px;

  .default-body-left {
    width: 200px;
    flex: none;
    display: flex;
    flex-direction: column;
  }

  .default-body-item {
    display: flex;
    height: 50px;
    flex: none;
    align-items: center;
    font-size: 16px;
    color: #6a6a6a;

    :deep(.el-input--prefix) {
      width: 100% !important;
    }

    :deep(.el-input__icon) {
      line-height: 32px;
    }

    :deep(.el-input__inner) {
      padding-left: 34px;
    }

    :deep(.el-input-number) {
      line-height: 31px;
      width: 100%;

      span {
        height: 30px;
      }
    }

    :deep(.el-radio-group) {
      display: flex;
      justify-content: flex-start;

      .el-radio__input {
        display: flex;
        align-items: center;
      }

      .el-radio {
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .el-radio__label {
          font-size: 16px;
        }
      }
    }

    .default-body-picture {
      display: flex;
      font-size: 12px;
      flex-direction: column;
      margin-left: 10px;
    }

  }

  .default-body-textarea {
    display: flex;
    min-height: 50px;
    align-items: center;
  }

  .default-body-title {
    display: flex;
    height: 100px;
    flex: none;
    align-items: center;
    justify-content: flex-start;
    font-size: 16px;
    color: #6a6a6a;
  }

  .default-body-image-list {
    display: flex;
    align-items: center;
    height: 100px;
    flex: none;
    overflow-y: auto;
    flex-direction: column;

    .default-body-image {
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #6a6a6a;
      width: 100%;

      .default-body-image-icon {
        width: 14px;
        height: 14px;
        flex: none;
        border-radius: 50%;
      }

      .default-body-image-name {
        width: 0;
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 10px;
      }
    }
  }


  .default-body-image:hover {
    color: #2681ff;
  }

  .default-body-text {
    height: 20px;
    flex: none;
    color: #ff4d4f;
  }

  .default-body-right {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
</style>